import React from 'react';

import InlineSelect, {
  InlineSelectProps
} from '../../../common/inline/InlineSelect';
import { productRiskOptions } from '../Product.interface';

const ProductRiskSelector: React.FC<InlineSelectProps> = (
  props: InlineSelectProps
) => {
  return <InlineSelect {...props} type='number' options={productRiskOptions} />;
};

export default ProductRiskSelector;
